import { APP_NAME } from "../../constants/keys";
export const emailValidation = {
  email: "required|email",
};
export const loginValidation = {
  email: "required|email",
  password: ["required"],
};
export const signupValidation = {
  email: "required|email",
  password: [
    "required",
    "regex:^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-zA-Z!@#$%^&*]).{8,}$",
    "confirmed",
  ],
  password_confirmation: "required",
  firstname: "required",
  lastname: "required",
};

export const jobApplyValidation = {
  email: "required|email",
  firstname: "required",
  lastname: "required",
  title: "required",
};

export const profileValidation = {
  email: "required|email",
  firstname: "required",
  lastname: "required",
};

export const accountConfirmValidation = {
  firstname: "required",
  lastname: "required",
};

export const supportValidation = {
  name: "required",
  emailAddress: "required|email",
  message: "required",
};

export const fileType = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const videoFileType = ["video/mp4", "video/quicktime", "video/webm"];

export const signupValidationMessage = {
  "required.email": "Please enter the missing fields \n",
  "required.password": "Please enter the missing fields",
  "required.password_confirmation": "Please enter the missing fields",
  "required.firstname": "Please enter the missing fields",
  "required.lastname": "Please enter the missing fields",
  email: "Please enter a valid email address",
  "regex.password": "The password doesn’t meet the minimum requirements",
  "confirmed.password": "The passwords don’t match",
  "required.title": "Please enter your most recent role",
};

export const accConfirmValidationMsg = {
  "required.firstname": "Please enter the missing fields",
  "required.lastname": "Please enter the missing fields",
};

export const supportValidationMsg = {
  "required.name": "Please enter your name",
  "required.emailAddress": "Please enter your email address",
  "required.message": "Please enter a message",
  emailAddress: "Please enter a valid email address",
};

export const applyJobValidationMessage = {
  selectOption: "Please Choose at least one option",
  wrongFileType: "Please upload only pdf or word documents",
  expeRequired:
    "Please enter the length of your experience for all the rows or enter '0' if the duration is not relevant",
  qualifRequired: "Please enter all the qualifications",
  expeYearMonth:
    "Please enter the length of your experience for all the rows or enter '0' if the duration is not relevant",
  mandatoryYearMonth:
    "Please enter the length of your experience for all the required rows or enter '0' if the duration is not relevant",
  somthingWrong: "An error occurred when we tried to submit your application. Please, try again.",
  requiredSteps: "You need to complete at least one of the job application options you selected",
  videoSizeToLarge: "The maximum allowed video duration to upload is 1 min, please upload a shorter video",
  wrondVideoFileType: "Please upload only mp4 or mov files",
};

export const mediaRecorderPermissionMessage = {
  videoPermission: "Your browser doesn't have permissions to use the camera, please check your browser's settings.",
  audioPermission:
    "Your browser doesn't have permissions to record from the microphone, please check your browser's settings.",
  audioAndVideoPermission:
    "Your browser doesn't have permissions to use the camera and the microphone, please check your browser's settings.",
  mediaDeviceNotFound: "Requested device not found.",
};

export const jobExperienceValidation = {
  experience: "required",
  experienceYears: ["required", "numeric"],
  experienceMonths: ["required", "numeric"],
};

export const changePassword = {
  password: [
    "required",
    "regex:^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-zA-Z!@#$%^&*]).{8,}$",
    "confirmed",
  ],
  password_confirmation: ["required"],
};

export const searchJobsValidationMessage = {
  position: "Please enter the search terms",
  miles: "Please select the search radius",
  city: "Please enter a city name",
  state: "Please select state",
  zipCode: "Please enter a zipCode",
  location: "Please enter a city and state or a zip code",
  cityState: "Please enter a city and state",
  noResultFound: "There are no results for the current filter, try to broaden the scope of your search.",
  zipCodeInvalid: "The valid format for zip code is 5 digits",
};

export const errorCode = {
  wrongPassword: "auth/wrong-password",
  alreadyMailexist: "auth/email-already-in-use",
  authEmailExist: "auth/email-already-exists",
  userNotFound: "auth/user-not-found",
  dismissPopup: "auth/popup-closed-by-user",
  cancelledPopup: "auth/cancelled-popup-request",
  emptyField: "auth/argument-error",
  invalidEmail: "auth/invalid-email",
  actionCodeExpire: "auth/invalid-action-code",
  toManyRequest: "auth/too-many-requests",
  profileNotFound: `${APP_NAME.toLowerCase()}/missing_profile`,
  missingParams: `${APP_NAME.toLowerCase()}/missing_parameter`,
};

export const errorMessage = {
  invalidCred: "The credentials you entered are not valid",
  others: "Oops! something went wrong; please try again",
  alreadyEmailExist: "An account already exists with this email address",
  invalidEmail: "The email address you entered is not valid",
  unRegisterdEmail: "Your email address has never been registered on " + APP_NAME,
  actionCodeExpire: "Link is expired, please try again",
  toManyRequest: "Oops! something went wrong; please try again leter",
  jobOpnNotFound: "This job opening no longer exists or is closed, please go back and select another job.",
  jobOpnOther:
    "There was an error retrieving the job you attempted to apply to. Please check your network connection and try again.",
  wrongPassword: "The password you entered is not correct",
  alreadyAccount: "There is already an account with the new email address",
};

export const validateZipcodes = (arr, handleZipcodeErrMsg) => {
  const checkZipcodes = !arr.some(isNaN);
  const zipcodeLength = arr.filter((item) => (item.length < 5 ? true : false));

  if (arr.length === 0) {
    handleZipcodeErrMsg("Please enter at least one zip code or disable email notifications");
    return false;
  } else if (!checkZipcodes || zipcodeLength.length > 0) {
    handleZipcodeErrMsg("The valid format for zip codes is 5 digits");
    return false;
  } else {
    return true;
  }
};

export const validateZipcode = (zipCode) => {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
};
